import { default as React, useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { DeviceName, DeviceType } from "../../redux/devices";
import { residentDevicesAfterGateCreator } from "../../redux/residents/selectors";
import { IAppState } from "../../redux/types";
import { ModalTypes } from "../status/Callbacks";
import { MarkForActivity } from "../status/devices";
import {
  BioPatchIcons,
  TextForDevice,
  VitalsIcons,
  WatchIcons,
} from "../status/utils";
const DevicesStatuses = ({
  residentId,
  callback,
}: {
  residentId: string;
  callback: (...args: any) => void;
}): JSX.Element => {
  const { t } = useTranslation("common");
  const devicesSelection = useMemo(() => residentDevicesAfterGateCreator(), []);
  const residentDevices = useSelector((state: IAppState) =>
    devicesSelection(state, residentId)
  );
  const onClose = useCallback(() => {
    callback(ModalTypes.BACK);
  }, [callback]);

  return (
    <div className="devises-status-holder">
      <div className="devises-status flex-column flex-center  flex-column-16">
        <p>{t("status:statusesLbl")}</p>

        {Object.keys(residentDevices).map((deviceId: string) => (
          <div className="flex-row flex-between" key={deviceId}>
            <div className="one-device-name">
              <MarkForActivity deviceId={deviceId} />
              <div>
                <div>
                  {residentDevices[deviceId].type === DeviceType.vitals
                    ? DeviceName.vitals
                    : residentDevices[deviceId].type === DeviceType.biopatch
                    ? DeviceName.biopatch
                    : DeviceName.watch}
                </div>
                <div className="posture text-size-14">
                  {residentDevices[deviceId].type !== DeviceType.watch && (
                    <TextForDevice
                      deviceType={residentDevices[deviceId].type}
                      residentId={residentId}
                      deviceId={deviceId}
                    />
                  )}
                </div>
              </div>
            </div>
            <div className="one-device-icons">
              {residentDevices[deviceId].type === DeviceType.biopatch && (
                <BioPatchIcons residentId={residentId} deviceId={deviceId} />
              )}
              {residentDevices[deviceId].type === DeviceType.vitals && (
                <VitalsIcons
                  residentId={residentId}
                  deviceId={deviceId}
                  size={16}
                />
              )}
              {residentDevices[deviceId].type === DeviceType.watch && (
                <WatchIcons residentId={residentId} deviceId={deviceId} />
              )}
            </div>
          </div>
        ))}
        <button
          className="btn secondary  with-icon save-view"
          onClick={onClose}
        >
          <i className="icon-close" />
          {t("buttons.Close")}
        </button>
      </div>
    </div>
  );
};

export default React.memo(DevicesStatuses);
